import { render, staticRenderFns } from "./attributeAdjustmentList.vue?vue&type=template&id=2057d6a6&scoped=true"
import script from "./attributeAdjustmentList.vue?vue&type=script&lang=js"
export * from "./attributeAdjustmentList.vue?vue&type=script&lang=js"
import style0 from "./attributeAdjustmentList.vue?vue&type=style&index=0&id=2057d6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2057d6a6",
  null
  
)

export default component.exports